// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/theme/css/dashboard.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-popup1 .content {
  min-width: 200px;
}

.custom-select {
  width: 65%;
}

label {
  width: 35%;
}

.chart canvas {
  display: block;
  padding: 20px;
  position: relative;
  height: 340px;
}

.error-message {
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 350px;
  margin-top: -10%;
  color: red;
}

.chart-container {
  padding-top: 10px;
}

.chart-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.contest-title {
  font-weight: bold;
  font-size: 18px;
  margin: 0 20px;
  color: #6f95cd;
}

.chart-nav-button {
  position: absolute;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  padding: 0;
}

.chart-nav-button.left {
  left: 10%;
}

.chart-nav-button.right {
  right: 10%;
}

.arrow-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-top: 2px solid #007bff;
  border-right: 2px solid #007bff;
  transform: rotate(45deg);
  margin: auto;
}

.arrow-icon.left {
  transform: rotate(-135deg);
}

.arrow-icon.right {
  transform: rotate(45deg);
}

.chart-nav-button:disabled {
  cursor: not-allowed;
  position: absolute;
  background: transparent;
  border: none;
  outline: none;
  width: 30px;
  height: 30px;
  padding: 0;
}

.chart-nav-button:disabled .arrow-icon {
  border-top: 2px solid #a9a9a9;
  border-right: 2px solid #a9a9a9;
}

.chart-title img {
  width: 25px;
  height: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/contest-and-incentive-details/tracking-dashboard-chart/tracking-dashboard-chart.component.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AACA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAEF;;AACA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAEF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,+BAAA;EACA,wBAAA;EACA,YAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AACA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAEF;;AACA;EACE,6BAAA;EACA,+BAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;AAEF","sourcesContent":["@import '../../../assets/theme/css/dashboard.css';\n\n.form-popup1 .content {\n  min-width: 200px;\n}\n\n.custom-select {\n  width: 65%;\n}\n\nlabel {\n  width: 35%;\n}\n\n.chart canvas {\n  display: block;\n  padding: 20px;\n  position: relative;\n  height: 340px;\n}\n\n.error-message {\n  display: flex;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  height: 350px;\n  margin-top: -10%;\n  color: red;\n}\n.chart-container {\n  padding-top: 10px;\n}\n\n.chart-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.contest-title {\n  font-weight: bold;\n  font-size: 18px;\n  margin: 0 20px;\n  color: #6f95cd;\n}\n\n.chart-nav-button {\n  position: absolute;\n  background: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n}\n\n.chart-nav-button.left {\n  left: 10%;\n}\n\n.chart-nav-button.right {\n  right: 10%;\n}\n\n.arrow-icon {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-top: 2px solid #007bff;\n  border-right: 2px solid #007bff;\n  transform: rotate(45deg);\n  margin: auto;\n}\n\n.arrow-icon.left {\n  transform: rotate(-135deg);\n}\n\n.arrow-icon.right {\n  transform: rotate(45deg);\n}\n\n.chart-nav-button:disabled {\n  cursor: not-allowed;\n  position: absolute;\n  background: transparent;\n  border: none;\n  outline: none;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n}\n\n.chart-nav-button:disabled .arrow-icon {\n  border-top: 2px solid #a9a9a9;\n  border-right: 2px solid #a9a9a9;\n}\n\n.chart-title img {\n  width: 25px;\n  height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
